import api from 'api'

import { CACHE_TAG_BILLING_NOTES_LIST } from '../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllBillingNotes: builder.query({
      query: ({ id }) => ({
        url: `/api/v1/core/accounts/${id}/billing-notes`,
        method: 'GET',
      }),
      providesTags: (result, error, { id }) => [CACHE_TAG_BILLING_NOTES_LIST, { type: CACHE_TAG_BILLING_NOTES_LIST, id }],
    }),
    getBillingNoteDetails: builder.query({
      query: ({ accountId, noteId }) => ({
        url: `/api/v1/core/accounts/${accountId}/billing-notes/${noteId}`,
        method: 'GET',
      }),
    }),
    getBillingNoteHistory: builder.query({
      query: ({ id, noteId }) => ({
        url: `/api/v1/core/accounts/${id}/billing-notes/${noteId}/history`,
        method: 'GET',
      }),
    }),
    createBillingNote: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api/v1/core/accounts/${id}/billing-notes`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: CACHE_TAG_BILLING_NOTES_LIST, id }],
    }),
    updateBillingNote: builder.mutation({
      query: ({ id, noteId, data }) => ({
        url: `/api/v1/core/accounts/${id}/billing-notes/${noteId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: CACHE_TAG_BILLING_NOTES_LIST, id }],
    }),
    deleteBillingNote: builder.mutation({
      query: ({ id, noteId }) => ({
        url: `/api/v1/core/accounts/${id}/billing-notes/${noteId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { id }) => [{ type: CACHE_TAG_BILLING_NOTES_LIST, id }],
    }),
    patchBillingNote: builder.mutation({
      query: ({ id, noteId, data }) => ({
        url: `/api/v1/core/accounts/${id}/billing-notes/${noteId}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: CACHE_TAG_BILLING_NOTES_LIST, id }],
    }),
  }),
})

export const {
  useGetAllBillingNotesQuery,
  useLazyGetAllBillingNotesQuery,
  useLazyGetBillingNoteDetailsQuery,
  useLazyGetBillingNoteHistoryQuery,
  useCreateBillingNoteMutation,
  useUpdateBillingNoteMutation,
  useDeleteBillingNoteMutation,
  usePatchBillingNoteMutation,
} = extendedApi
